/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KinnserPatientCreatedPatient } from './KinnserPatientCreatedPatient';
import {
    KinnserPatientCreatedPatientFromJSON,
    KinnserPatientCreatedPatientFromJSONTyped,
    KinnserPatientCreatedPatientToJSON,
    KinnserPatientCreatedPatientToJSONTyped,
} from './KinnserPatientCreatedPatient';
import type { KinnserPatientInput } from './KinnserPatientInput';
import {
    KinnserPatientInputFromJSON,
    KinnserPatientInputFromJSONTyped,
    KinnserPatientInputToJSON,
    KinnserPatientInputToJSONTyped,
} from './KinnserPatientInput';

/**
 * 
 * @export
 * @interface KinnserPatient
 */
export interface KinnserPatient {
    /**
     * Latest async submission ID
     */
    id: string;
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    operation?: KinnserPatientOperationEnum;
    /**
     * 
     */
    submitted_by_user_id?: string;
    /**
     * 
     */
    submitted_form_data: KinnserPatientInput;
    /**
     * WellSky episode key
     */
    external_admission_id?: string;
    /**
     * 
     */
    status: KinnserPatientStatusEnum;
    /**
     * 
     */
    submitted_at: string;
    /**
     * 
     */
    error_message?: string;
    /**
     * 
     */
    response?: { [key: string]: any; };
    /**
     * 
     */
    created_patient?: KinnserPatientCreatedPatient;
    /**
     * 
     */
    external_ehr_patient_admission_id?: string;
}


/**
 * @export
 */
export const KinnserPatientOperationEnum = {
    CreatePatient: 'create_patient',
} as const;
export type KinnserPatientOperationEnum = typeof KinnserPatientOperationEnum[keyof typeof KinnserPatientOperationEnum];

/**
 * @export
 */
export const KinnserPatientStatusEnum = {
    Pending: 'pending',
    InProgress: 'in_progress',
    Succeeded: 'succeeded',
    Failed: 'failed',
} as const;
export type KinnserPatientStatusEnum = typeof KinnserPatientStatusEnum[keyof typeof KinnserPatientStatusEnum];


/**
 * Check if a given object implements the KinnserPatient interface.
 */
export function instanceOfKinnserPatient(value: object): value is KinnserPatient {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('submitted_form_data' in value) || value['submitted_form_data'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('submitted_at' in value) || value['submitted_at'] === undefined) return false;
    return true;
}

export function KinnserPatientFromJSON(json: any): KinnserPatient {
    return KinnserPatientFromJSONTyped(json, false);
}

export function KinnserPatientFromJSONTyped(json: any, ignoreDiscriminator: boolean): KinnserPatient {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'operation': json['operation'] == null ? undefined : json['operation'],
        'submitted_by_user_id': json['submitted_by_user_id'] == null ? undefined : json['submitted_by_user_id'],
        'submitted_form_data': KinnserPatientInputFromJSON(json['submitted_form_data']),
        'external_admission_id': json['external_admission_id'] == null ? undefined : json['external_admission_id'],
        'status': json['status'],
        'submitted_at': json['submitted_at'],
        'error_message': json['error_message'] == null ? undefined : json['error_message'],
        'response': json['response'] == null ? undefined : json['response'],
        'created_patient': json['created_patient'] == null ? undefined : KinnserPatientCreatedPatientFromJSON(json['created_patient']),
        'external_ehr_patient_admission_id': json['external_ehr_patient_admission_id'] == null ? undefined : json['external_ehr_patient_admission_id'],
    };
}

export function KinnserPatientToJSON(json: any): KinnserPatient {
    return KinnserPatientToJSONTyped(json, false);
}

export function KinnserPatientToJSONTyped(value?: KinnserPatient | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'operation': value['operation'],
        'submitted_by_user_id': value['submitted_by_user_id'],
        'submitted_form_data': KinnserPatientInputToJSON(value['submitted_form_data']),
        'external_admission_id': value['external_admission_id'],
        'status': value['status'],
        'submitted_at': value['submitted_at'],
        'error_message': value['error_message'],
        'response': value['response'],
        'created_patient': KinnserPatientCreatedPatientToJSON(value['created_patient']),
        'external_ehr_patient_admission_id': value['external_ehr_patient_admission_id'],
    };
}

